import React, { useState, useRef, useEffect } from "react";
import { DoubleArrow } from "@mui/icons-material";
import * as Mui from "@mui/material";
import { tooltipStyleProps } from "services/constants/Styles";
import { Tooltip, Drawer } from "@mui/material";
import { customAPI } from "services/utils/CustomAPI";
import { useSelector } from "react-redux";
import { showToast } from "services/utils/Status";
import { EditPayRunCycle } from "./EditPayRunCycle";
import { ConfirmationDialog } from "components/CustomComponents/ConfirmationDialog";
import { CustomizedDatePicker } from "components/CustomComponents/CustomizedDatePicker";
import { PaycycleHistoryHeader } from "pages/PayRoll/PayRollHeaders";
import { TableEmptyState } from "components/CustomComponents/EmptyState";
import { useForm } from "react-hook-form";
import dayjs from "dayjs";
import { useFetch } from "services/hooks/useFetch";
import { Loader } from "components/Loader";

import {
  deactivateText,
  deleteMessage,
  unSavedText,
  unSavedMessage,
  drawerStyle,
  editIconStyle,
  deleteIconStyle,
  doubleArrowStyle,
  parentBoxStyle,
  childBoxStyleSpaceBetween,
  themes,
  scrollTop,
  tableRowSize,
  stickyHeader,
  infoStyle,
  StatusBadge,
  displayFlexItem,
} from "services/constants";
import {
  CalendarToday as CalendarIcon,
  AccessTime as CalendarClockIcon,
  Edit as EditIcon,
  PowerSettingsNew as PowerSettingsNewIcon,
  AccountBalanceWallet as WalletIcon,
} from "@mui/icons-material";
import {
  Box,
  Typography,
  IconButton,
  Paper,
  Card,
  CardContent,
} from "@mui/material";

export const ViewPayrunCycle = ({
  onClose,
  payCycleDetails,
  reCallApi,
  setGetId,
  setPayrunViewedItem,
  screenAccess,
}) => {
  const { domain } = useSelector((state) => state.tokenReducer);
  const [isEditPanelOpen, setIsEditPanelOpen] = useState(false);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
  const [isDeactivateButton, setIsDeactivateButton] = useState(false);
  const [page, setPage] = useState(0);
  const containerRef = useRef(null);
  const { result: payrunCycleData, loading } = useFetch(
    `${domain}payroll/operations/payrollprocessing/payrollruncycle/payschedules/?status=Pay_run_histroy&company_id=${payCycleDetails?.company}&pay_run_cycle_id=${payCycleDetails?.id}`
  );

  const { handleSubmit, reset, control } = useForm({
    mode: "onBlur",
    defaultValues: {
      payrun_end_date: payCycleDetails?.start_date
        ? dayjs(payCycleDetails?.start_date.split("-").reverse().join("-"))
        : null,
    },
  });

  const payrollData = [
    {
      id: 1,
      icon: WalletIcon,
      label: "Pay Cycle",
      value: payCycleDetails?.pay_run_cycle_type,
      iconBgColor: "#09bd711a",
      iconBorderColor: "#09bd71",
      iconColor: "#09bd71",
    },
    {
      id: 2,
      icon: CalendarIcon,
      label: "Start Day",
      value:
        payCycleDetails?.pay_run_cycle_type === "Custom"
          ? "-"
          : payCycleDetails?.start_day ?? payCycleDetails?.date_of_month,
      iconBgColor: "#3c73e71a",
      iconBorderColor: "#3c73e7",
      iconColor: "#3c73e7",
    },
    {
      id: 3,
      icon: CalendarClockIcon,
      label: "Payrun Starts On",
      value: payCycleDetails?.start_date,
      iconBgColor: "#bd09091a",
      iconBorderColor: "#d71515",
      iconColor: "#d71515",
    },
  ];

  const hanldeEditPanel = () => {
    setIsEditPanelOpen(true);
  };

  const onSubmit = async (data) => {
    const response = await customAPI(
      `${domain}payroll/setup/payruncycle/pay-run-cycles/${payCycleDetails?.id}`,
      "PATCH",
      {
        end_date: data?.payrun_end_date.format("YYYY-MM-DD"),
      }
    );
    if (response.ok) {
      showToast("success", response?.responseDetails?.message);
      setPayrunViewedItem(false);
      reCallApi(true);
      onClose();
    } else {
      showToast("error", response?.message);
    }
  };

  const handleClosePanel = () => {
    if (hasUnsavedChanges) {
      setShowConfirmationDialog(true);
    } else {
      setIsEditPanelOpen(false);
    }
  };

  const handleConfirmClose = () => {
    setShowConfirmationDialog(false);
    setIsEditPanelOpen(false);
  };

  const handleCancelClose = () => {
    setShowConfirmationDialog(false);
    reset();
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const [rowsPerPage, setRowsPerPage] = useState(25);

  useEffect(() => {
    scrollTop(containerRef);
  }, [page]);

  return loading ? (
    <Loader />
  ) : (
    <>
      <Box sx={parentBoxStyle}>
        <ConfirmationDialog
          open={showConfirmationDialog}
          onClose={handleCancelClose}
          onConfirm={
            isDeactivateButton ? handleSubmit(onSubmit) : handleConfirmClose
          }
          title={isDeactivateButton ? deactivateText : unSavedText}
          message={isDeactivateButton ? deleteMessage : unSavedMessage}
          confirmText={isDeactivateButton ? "Deactivate" : "Exit"}
          showChildren={isDeactivateButton}
          cancelText="Cancel"
        >
          <Box>
            <Typography sx={{ fontWeight: 600 }}>End Date</Typography>
            <CustomizedDatePicker
              name="payrun_end_date"
              control={control}
              required
              requiredMessage="Payrun end day is required"
              placeholder="Select payrun cycle end date"
              disablePast={
                payCycleDetails?.start_date
                  ? dayjs(
                      payCycleDetails?.start_date.split("-").reverse().join("-")
                    )
                  : null
              }
            />
          </Box>
        </ConfirmationDialog>

        <Paper elevation={0} sx={{ borderRadius: 0 }}>
          <Box>
            <Box sx={childBoxStyleSpaceBetween}>
              <IconButton onClick={onClose} sx={doubleArrowStyle}>
                <DoubleArrow />
              </IconButton>
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <Tooltip title="Inactivate" arrow slotProps={tooltipStyleProps}>
                  <IconButton
                    onClick={() => {
                      if (screenAccess) {
                        setShowConfirmationDialog(true);
                        setIsDeactivateButton(true);
                      } else {
                        showToast(
                          "error",
                          `Access denied: You are not authorized to inactivate payrun cycle `
                        );
                      }
                    }}
                    sx={deleteIconStyle}
                    disabled={
                      payCycleDetails?.status === "Inactive" ||
                      payCycleDetails?.status === "Scheduled"
                    }
                  >
                    <PowerSettingsNewIcon />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Edit" arrow slotProps={tooltipStyleProps}>
                  <IconButton
                    onClick={() => {
                      if (screenAccess) {
                        hanldeEditPanel();
                        setIsDeactivateButton(false);
                      } else {
                        showToast(
                          "error",
                          `Access denied: You are not authorized to edit payrun cycle`
                        );
                      }
                    }}
                    disabled={
                      payCycleDetails?.status === "Active" ||
                      payCycleDetails?.status === "Inactive"
                    }
                    sx={editIconStyle}
                  >
                    <EditIcon />
                  </IconButton>
                </Tooltip>
              </Box>
            </Box>

            <Box sx={{ ml: 2.2 }}>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>
                {payCycleDetails?.name}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                View your payroll cycle configuration.
              </Typography>
            </Box>
          </Box>
        </Paper>

        <Box sx={{ flexGrow: 1, overflow: "auto", p: 2 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: 3,
              mt: 4,
              mb: 3,
            }}
          >
            {payrollData.map((item) => {
              const IconComponent = item.icon;
              return (
                <Card
                  key={item.id}
                  sx={{
                    width: 220,
                    height: 123,
                    bgcolor: "#3c73e70d",
                    borderRadius: 1,
                    boxShadow: "0px 4px 4px rgba(0,0,0,0.25)",
                    border: 0,
                  }}
                >
                  <CardContent
                    sx={{
                      p: 2,
                      display: "flex",
                      flexDirection: "column",
                      height: "100%",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: item?.id === 3 ? 1 : 2,
                        mb: 1,
                      }}
                    >
                      <Box
                        sx={{
                          width: 35,
                          height: 35,
                          bgcolor: item.iconBgColor,
                          border: `0.5px solid ${item.iconBorderColor}`,
                          borderRadius: 1,
                          boxShadow: "0px 1px 2px rgba(0,0,0,0.25)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          mb: 1.5,
                        }}
                      >
                        <IconComponent
                          width={16}
                          height={16}
                          style={{ color: item.iconColor }}
                        />
                      </Box>

                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: 600,
                          mb: "auto",
                        }}
                      >
                        {item.label}
                      </Typography>
                    </Box>

                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 700,
                        color: "#32325D",
                      }}
                    >
                      {item.value}
                    </Typography>
                  </CardContent>
                </Card>
              );
            })}
          </Box>
          <Box sx={{ mb: 2 }}>
            <Box>
              <Typography sx={{ fontWeight: 600 }}>Paycycle History</Typography>
              <Typography {...infoStyle}>
                Overview of these pay cycles and their progress.
              </Typography>
            </Box>
            <Mui.TableContainer
              ref={containerRef}
              sx={{
                maxHeight: 550,
                mt: 2,
                overflow: "auto",
              }}
            >
              <Mui.Table className="border" sx={{ minWidth: "100%" }}>
                <Mui.TableHead sx={stickyHeader}>
                  <Mui.TableRow sx={tableRowSize}>
                    {PaycycleHistoryHeader?.map((value, index) => (
                      <Mui.TableCell
                        key={index}
                        sx={{
                          color: themes.headLine,
                          fontWeight: "bold",
                          whiteSpace: "nowrap",
                          minWidth: "150px",
                        }}
                      >
                        {value?.name}
                      </Mui.TableCell>
                    ))}
                  </Mui.TableRow>
                </Mui.TableHead>
                <Mui.TableBody>
                  {payrunCycleData?.length === 0 ? (
                    <TableEmptyState dataLength={payrunCycleData} />
                  ) : (
                    payrunCycleData
                      ?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      ?.map((value, rowIndex) => (
                        <Mui.TableRow key={rowIndex} sx={tableRowSize}>
                          {PaycycleHistoryHeader.map((head, cellIndex) => (
                            <Mui.TableCell
                              key={cellIndex}
                              sx={{
                                whiteSpace: "nowrap",
                                minWidth: "150px",
                              }}
                            >
                              {head.key === "status" ? (
                                <Mui.Box sx={displayFlexItem}>
                                  <StatusBadge
                                    statusId={
                                      value?.status === "Processed"
                                        ? 1
                                        : value?.status === "Submitted"
                                        ? 2
                                        : 3
                                    }
                                    label={value?.status || "N/A"}
                                  />
                                </Mui.Box>
                              ) : (
                                value[head.key] ?? "N/A"
                              )}
                            </Mui.TableCell>
                          ))}
                        </Mui.TableRow>
                      ))
                  )}
                </Mui.TableBody>
              </Mui.Table>
              {payrunCycleData?.length > 25 && (
                <Mui.TablePagination
                  className="custom-pagination"
                  component="div"
                  rowsPerPageOptions={[25, 50, 75, 100]}
                  count={payrunCycleData?.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              )}
            </Mui.TableContainer>
          </Box>
        </Box>
      </Box>
      <Drawer
        anchor="right"
        open={isEditPanelOpen}
        onClose={() => {
          handleClosePanel();
        }}
        sx={drawerStyle}
      >
        <EditPayRunCycle
          onClose={handleClosePanel}
          payCycleDetails={payCycleDetails}
          reCallApi={reCallApi}
          setGetId={setGetId}
          setIsEditPanelOpen={setIsEditPanelOpen}
          setPayrunViewedItem={setPayrunViewedItem}
          setHasUnsavedChanges={setHasUnsavedChanges}
        />
      </Drawer>
    </>
  );
};
